import {IUserInformationsWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";
import {CerbaAuthService, CerbaCookieService, CookieConstantes} from "@digicerba/common";
import * as lodash from "lodash";

@Injectable()
export class AccessResolver implements Resolve<Boolean> {

  constructor(private iUserInformationsWebServiceClient: IUserInformationsWebServiceClient, private cerbaAuthService: CerbaAuthService,
              private cookieService: CerbaCookieService) {
  }

  resolve() {
    if (this.cookieService.getCoockieValue(CookieConstantes.COOKIE_AUTH) != null) {
      return this.check();
    }
    else {
      let queryParams = window.location.search;
      if (!queryParams) {
        return false;
      }
      let params = queryParams.split('&');
      let lang = lodash.find(params, (p) => {
        return p.indexOf("lang=") >= 0;
      });
      if (lang.indexOf("?") >= 0) {
        lang = lang.substring(1);
      }
      console.log("default check resolve to true");
      return true;
    }
  }

  check() {
    let checkCall = this.iUserInformationsWebServiceClient.checkAccess();
    checkCall.subscribe(allowed => {
    }, (error) => {
      this.cerbaAuthService.unauthorized(error.status);
    });
    return checkCall;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/check.resolver.ts